import { GRAPH_COLORED_NODE_CLASS_NAME, GRAPH_DEFAULT_NODE_CLASS_NAME, GRAPH_GROUP_NODE_LABEL_CLASS_NAME } from "Common/componentUtils/constants";
import { createGlobalStyle } from "styled-components";
import { yfilesBaseStyles, yfilesSelectedNodeStyles, yfilesTemplatesStyles, yfilesHighlightedStyles } from "./css/yWorksCss";
export default createGlobalStyle `
  ${yfilesTemplatesStyles}

  .yfiles-svgpanel > div[aria-hidden="true"] { // hide license message
    display: none;
  }

  .yfiles-canvascomponent-svg {
    ${yfilesBaseStyles}

    g.yfiles-selected {
      ${yfilesSelectedNodeStyles}
    }
    g:not(.yfiles-selected) {
      > rect.${GRAPH_DEFAULT_NODE_CLASS_NAME}.${GRAPH_COLORED_NODE_CLASS_NAME} {
        fill: #fff !important;
        fill-opacity: 1;
      }
    }

    g.yfiles-highlighted {
      ${yfilesHighlightedStyles}
    }
  }

  [data-zoom="increased"] > .yfiles-canvascomponent foreignObject .${GRAPH_GROUP_NODE_LABEL_CLASS_NAME} .dx-freespace-row,
  [data-zoom="original"] > .yfiles-canvascomponent foreignObject .${GRAPH_GROUP_NODE_LABEL_CLASS_NAME} .dx-freespace-row {
    display: none;
  }
  [data-zoom="decreased"] > .yfiles-canvascomponent foreignObject .${GRAPH_GROUP_NODE_LABEL_CLASS_NAME} .dx-freespace-row {
    display: block !important;
    height: 1em !important;
  }
`;
